import * as api from '../api';

export const fetchUserGroups = (args: any): Promise<any> => {
  return api.callGet(`/user-groups`, args);
};
